var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main_picture"}},[_c('MainPicture',{attrs:{"image-position-y":_vm.rightContainerScrollPercent + '%',"image-src":_vm.mainImageUrl}},[_c('FloatButton',{attrs:{"link-option":"details","text":"DETAILS"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }